import SettingsMetaData from "../../../../Components/Hooks/useSettingsMetaData";


const StatusTask = () => {
  return (
    <SettingsMetaData propertyName={"Status_Task"} viewPropertyName={"Status"} />
  );
};
export default StatusTask;